import * as requests from "../../coraWebComponents/utils/requests";
import urls from "../../constants/Urls";

const buildZP_C_VYSLEDOK_VYJADRENIA = () => {
  return `${urls.ZP_C_VYSLEDOK_VYJADRENIA}`;
};

export const getZP_C_VYSLEDOK_VYJADRENIA = async () => {
  const url = buildZP_C_VYSLEDOK_VYJADRENIA();
  try {
    let res = await requests.get(url);
    return res;
  } catch (error) {
    throw error;
  }
};
